module.exports = __webpack_public_path__ + "static/media/phi-logo.29ad8e6c.png";